howspace.scroller = (() => {
    'use strict';

    let hash = null;
    let scrollToElement = null;

    const checkHash = () => {
        if (!howspace.workspace.page.getIsReadyToScroll()) {
            // Page is not yet ready to scroll.
            return;
        }

        if (scrollToElement !== null) {
            // There is already an element to scroll to.
            checkScroll();
            return;
        }

        if (hash === null) {
            // Empty hash, no need to investigate the hash further.
            return;
        }

        let widgetId = null;
        let commentId = null;
        let replyId = null;
        let mode = 'notifications';

        let widget = null;
        let comment = null;
        let reply = null;

        hash.split(':').forEach((hashParts) => {
            const hashPart = hashParts.split('-');
            const key = hashPart[0] || null;
            const value = hashPart[1] || null;
            if (key === 'widget') {
                widgetId = value;
                widget = document.getElementById('widget-' + widgetId);
            } else if (key === 'comment') {
                commentId = value;
                comment = document.querySelector('article.comment[data-id="' + commentId + '"]');
            } else if (key === 'reply') {
                replyId = value;
                reply = document.querySelector('article.reply[data-id="' + replyId + '"]');
            } else if (key === 'type') {
                mode = value;
            }
        });
        hash = null;

        if (replyId !== null) {
            setHashScrollCommentOrReply(reply, widgetId, mode === 'notifications' ? null : commentId, 'article.reply[data-id="' + replyId + '"]');
        } else if (commentId !== null) {
            setHashScrollCommentOrReply(comment, widgetId, mode === 'notifications' ? null : commentId, 'article.comment[data-id="' + commentId + '"]');
        } else if (widget !== null) {
            scrollToElement = widget;
        }

        checkScroll();
    };

    const setHashScrollCommentOrReply = (commentOrReply, widgetId, commentId, selector) => {
        scrollToElement = commentOrReply;
        if (scrollToElement === null) {
            // The comment or reply is not on the display, load more comments and try again.
            loadComments(widgetId, commentId, () => {
                scrollToElement = document.querySelector(selector);
                if (scrollToElement === null) {
                    // The comment or reply is still not found. This might happen if the comment/reply is still behind
                    // "load more comments". Just pick the first unread comment/reply and scroll to that.
                    scrollToElement = document.querySelector('article.comment.new:not(.seen), article.reply.new:not(.seen)');
                }
                checkScroll();
            });
        }
    };

    const loadComments = (widgetId, commentId = null, readyFn = null) => {
        const widget = $('#widget-' + widgetId);
        if (widget.length === 0) {
            return;
        }
        const commentsLister = widget.find('.howspace-lister.comments');

        scrollToElement = widget[0];
        checkScroll();

        const adminLoadMoreBtn = widget.find('.admin-load-more-comments-btn');
        if (adminLoadMoreBtn.is(':visible')) {
            howspace.widgets.clearFilters(widget);
            howspace.whatsNew.destroy(commentsLister);
            commentsLister.dataAndAttr('uri', commentsLister.data('url'));
            adminLoadMoreBtn.addClass('d-none');
        }

        // We manipulate the HTML 5 data attributes and jQuery data values here because in CSS
        // we depend on the attributes, but in the getFilter-function we read jQuery data.
        widget.removeDataAndAttr('limit-results-to-comment-id');
        widget.removeDataAndAttr('limit-results-to-whats-new');

        if (commentId !== null) {
            // Limit results to a single comment.
            widget.dataAndAttr('limit-results-to-comment-id', commentId);
        } else {
            // Limit results to comments that contain what's new.
            widget.dataAndAttr('limit-results-to-whats-new', true);
        }

        if (typeof readyFn === 'function') {
            commentsLister[0].addEventListener(howspace.components.lister.LIST_ITEMS_RENDERED, readyFn, {once: true});
        }

        howspace.commentsTrait.reloadComments(widget);
    };

    const checkPathMode = (elem) => {
        const container = elem?.closest('.page-container');
        if (container?.classList.contains('d-none') && $('.self-directed-path-navigator').is(':visible')) {
            // User is in self-directed path mode and the scroll to element is in another phase than the one that
            // is currently visible. Show the correct phase in the path.
            howspace.workspace.page.pathMode.showContainer(container.dataset.containerId);
        }
    };

    const checkKanbanUncategorized = (elem) => {
        elem?.closest('.comment-category.uncategorized.collapsed')?.click();
    };

    const expandAdminOnlyCollapse = (elem) => {
        if (!elem) {
            return;
        }
        const adminOnlyWrapper = elem.closest('.container-admin-only-wrapper');
        if (!adminOnlyWrapper) {
            return;
        }
        const adminOnlyCollapse = adminOnlyWrapper.querySelector('.howspace-collapse-initialized');
        if (adminOnlyCollapse !== null && adminOnlyCollapse.getAttribute('aria-expanded') !== 'true') {
            // The element is inside an admin-only wrapper that is collapsed, expand it.
            howspace.components.collapse.expand(adminOnlyCollapse, false);
        }
    };

    const showHiddenReplies = (reply) => {
        const comment = reply.closest('.comment');
        comment.querySelector('.replies.d-none')?.classList.remove('d-none');

        if (reply.classList.contains('d-none')) {
            // Reply is hidden, show it and all the following hidden replies.
            reply.classList.remove('d-none');

            // Show all replies after the current one.
            $(reply).nextAll('.reply.d-none').removeClass('d-none');

            // Update the count in the "show more replies" button.
            const hiddenRepliesWrapper = comment.querySelector('.comment-hidden-replies-wrapper');
            const showMoreRepliesBtn = hiddenRepliesWrapper.querySelector('.show-more-replies-btn');
            const hiddenRepliesCount = comment.querySelectorAll('.reply.d-none').length;
            showMoreRepliesBtn.querySelector('.btn-text').dataset.count = hiddenRepliesCount;

            if (hiddenRepliesCount === 0) {
                hiddenRepliesWrapper.classList.add('d-none');
            }
        }
    };

    const getScrollChain = (elem, chain = []) => {
        elem = howspace.getDOMElement(elem);
        let scrollingParent = howspace.getClosestScrollingParent(elem)[0];
        if (scrollingParent === window) {
            // Window does not have getBoundingClientRect() method so use document element (<html>) instead.
            scrollingParent = document.documentElement;
        }

        if (elem !== scrollingParent) {
            chain.push({
                elem: elem,
                scrollingParent: scrollingParent,
            });
            if (scrollingParent !== document.documentElement && getComputedStyle(scrollingParent).position === 'static') {
                return getScrollChain(scrollingParent, chain);
            }
        }

        if (chain.length === 0) {
            chain.push({
                elem: elem,
                scrollingParent: document.documentElement,
            });
        }
        return chain;
    };

    const checkScroll = () => {
        if (!howspace.workspace.page.getIsReadyToScroll()) {
            return;
        }

        scrollToElement = howspace.getDOMElement(scrollToElement);
        if (!scrollToElement) {
            return;
        }

        checkPathMode(scrollToElement);
        checkKanbanUncategorized(scrollToElement);
        expandAdminOnlyCollapse(scrollToElement);
        if (scrollToElement.classList.contains('reply')) {
            showHiddenReplies(scrollToElement);
        }

        // Everything is supposed to be ready, but sometimes the UI is still wiggling a bit.
        // Wait 100 ms before scrolling in order for the scroll to work more reliably.
        setTimeout(() => {
            if (!scrollToElement) {
                // Element to scroll to was removed while waiting.
                return;
            }

            const topHeight = $('#top').height();
            real.loopReverse(getScrollChain(scrollToElement), (step) => {
                const parentElem = step.scrollingParent;
                const elemRect = step.elem.getBoundingClientRect();
                const parentRect = parentElem.getBoundingClientRect();

                let top = elemRect.top - parentRect.top;
                let left = elemRect.left - parentRect.left;
                let topMargin = 0;
                if (parentElem === document.documentElement) {
                    topMargin = topHeight + 16;
                } else {
                    top += parentElem.scrollTop;
                    left += parentElem.scrollLeft;
                }

                parentElem.scrollTo({
                    behavior: 'smooth',
                    top: top - topMargin,
                    left: left - 16,
                });
            });

            scrollToElement = null;
        }, 100);
    };

    const isElemVisible = (elem, visibilityRatio = 0.1) => {
        elem = howspace.getDOMElement(elem);
        const rect = elem.getBoundingClientRect();

        const elementHeight = rect.height;
        if (elementHeight === 0) {
            return false;
        }

        const visibleTop = Math.max(0, rect.top);
        const visibleBottom = Math.min(window.innerHeight, rect.bottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const elemVisibleRatio = visibleHeight / elementHeight;

        return elemVisibleRatio >= visibilityRatio;
    };

    return {
        setHash: (newHash) => {
            hash = newHash;
            checkHash();
        },
        readyToScroll: () => {
            checkHash();
        },
        /**
         * Scrolls to element. Optional visibilityRatio (0-1) skips scrolling if element is already visible enough.
         */
        scrollToElement: (elem, visibilityRatio = 0) => {
            if (visibilityRatio > 0 && isElemVisible(elem, visibilityRatio)) {
                return;
            }
            scrollToElement = elem;
            checkScroll();
        },
        loadComments: loadComments
    };
})();
